import { useMutation, useQueryClient } from '@tanstack/react-query';
import http from 'helpers/requests';

export const useCreateOperator = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (operator) => {
      const response = await http.post('/operators', operator);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['loggedOperator'] });
    },
  });
};
